import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useTheme } from "@/context/ThemeContext";
import { desglose } from "@/lib/reporteAnual";
import { kgFmt, fmtKg, valor } from "@/components/control/ProyeccionTabla";
import { CheckCircle2, XCircle } from "lucide-react";

function Veredicto({ cumple }) {
  return cumple
    ? <div className="flex items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-bold text-emerald-800" data-testid="desglose-veredicto" data-cumple="true"><CheckCircle2 className="w-4 h-4 shrink-0" />Resultado es MAYOR ó IGUAL a la utilidad Base: SE LIBERA LA SEMANA</div>
    : <div className="flex items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold text-red-800" data-testid="desglose-veredicto" data-cumple="false"><XCircle className="w-4 h-4 shrink-0" />Resultado es MENOR a la utilidad Base: NO ES APROBADA LA SEMANA</div>;
}

const PAL = {
  light: { bg: "#ffffff", fg: "#0f172a", muted: "#64748b", line: "#e2e8f0", pill: "#f1f5f9", pillOn: "#0f172a", pillOnFg: "#ffffff", badge: "#f1f5f9", total: "#f8fafc" },
  dark: { bg: "#000000", fg: "#f8fafc", muted: "#94a3b8", line: "#1f2937", pill: "#111111", pillOn: "#262626", pillOnFg: "#ffffff", badge: "#1f1f1f", total: "#0b0b0b" },
};
const SIGLAS = /^(P\.V\.|P\.C\.|HGN|B\d)$/;
const etiqueta = (s) => s.split(" ").map((w, i) => (SIGLAS.test(w) ? w : i ? w.toLowerCase() : w.charAt(0) + w.slice(1).toLowerCase())).join(" ");
const Badge = ({ p, children, testid }) => <span className="rounded-full px-2.5 py-0.5 text-xs font-bold" style={{ background: p.badge, color: p.fg }} data-testid={testid}>{children}</span>;

function Detalle({ col, rows, p }) {
  const kg = col.kg;
  const filas = rows.filter((r) => !r.gap && !r.pending);
  const cell = "py-2.5 text-right tabular-nums";
  return (
    <div className="rounded-xl px-3 py-3 sm:px-4" data-testid={`desglose-panel-${col.week}`}>
      <div className="flex items-center justify-between gap-3">
        <p className="text-base font-semibold" style={{ color: p.fg }}>{col.titulo === "Semana completa" || col.titulo === "Total semana" ? col.titulo : `${col.titulo} – ${col.nombre}`}</p>
        <Badge p={p} testid={`desglose-dias-${col.week}`}>{col.dias} días</Badge>
      </div>
      <p className="mt-1 text-xs" style={{ color: p.muted }} data-testid={`desglose-periodo-${col.week}`}>{col.periodo}</p>
      <table className="mt-3 w-full text-sm" style={{ color: p.fg }}>
        <thead>
          <tr style={{ borderBottom: `1px solid ${p.line}` }}>
            <th className="py-2 text-left font-medium">Concepto</th>
            <th className="py-2 text-right font-medium">$/kg</th>
            <th className="py-2 text-right font-medium">Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ borderBottom: `1px solid ${p.line}` }} data-testid={`desglose-${col.week}-venta`}>
            <td className="py-2.5">Venta en kilos</td><td className={cell} style={{ color: p.muted }}>—</td><td className={cell}>{kgFmt(kg)}</td>
          </tr>
          {filas.map((r) => {
            const v = r.w(col);
            return (
              <tr key={r.k} style={{ borderBottom: `1px solid ${p.line}`, background: r.total ? p.total : undefined }} className={r.total ? "font-semibold" : ""} data-testid={`desglose-${col.week}-${r.k}`}>
                <td className="py-2.5 pr-3">{etiqueta(r.label)}</td>
                <td className={cell} style={{ color: p.muted }}>{v == null || !kg ? "—" : fmtKg(r, v / kg)}</td>
                <td className={cell}>{valor(r, v)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export function DesgloseSemana({ semana, rows, onClose, cumple }) {
  const { theme } = useTheme();
  const p = PAL[theme === "dark" ? "dark" : "light"];
  const cols = semana ? desglose(semana) : [];
  const [tab, setTab] = useState(null);
  const sel = cols.find((c) => c.week === tab) || cols[cols.length - 1];
  const total = cols[cols.length - 1];
  return (
    <Dialog open={!!semana} onOpenChange={(o) => { if (!o) { setTab(null); onClose(); } }}>
      <DialogContent className="w-[95vw] max-w-xl max-h-[90vh] overflow-y-auto rounded-2xl p-4 sm:p-5" style={{ background: p.bg, color: p.fg, borderColor: p.line }} data-testid="ra-desglose">
        {semana && <>
          <div className="flex items-start justify-between gap-3 pr-6">
            <div>
              <DialogTitle className="text-xl font-bold" style={{ color: p.fg }}>Detalle – Semana {semana.week}</DialogTitle>
              <DialogDescription className="mt-1 text-xs" style={{ color: p.muted }}>{total.encabezado}</DialogDescription>
            </div>
            <Badge p={p} testid="desglose-dias-semana">{semana.dias} días</Badge>
          </div>
          {cols.length > 1 && (
            <div className="grid grid-cols-3 gap-1.5" data-testid="desglose-tabs">
              {cols.map((c) => {
                const on = c === sel;
                return (
                  <button key={c.week} type="button" onClick={() => setTab(c.week)} className="rounded-full px-2 py-1.5 text-xs font-semibold transition-colors sm:text-sm"
                    style={{ background: on ? p.pillOn : p.pill, color: on ? p.pillOnFg : p.muted }} data-testid={`desglose-tab-${c.week}`}>{c.titulo}</button>
                );
              })}
            </div>
          )}
          {cumple != null && <Veredicto cumple={cumple} />}
          <Detalle col={sel} rows={rows} p={p} />
          <p className="text-xs" style={{ color: p.muted }}>{cols.length > 1 ? "Cada complementaria usa solo los días y datos de su mes; Total semana consolida ambas." : "Los siete días pertenecen al mismo mes."}</p>
        </>}
      </DialogContent>
    </Dialog>
  );
}
